// numeral
import numeral from 'numeral';

const integer = (value) => Number(numeral(value).format('0'));

export default integer;
